import { Box, Typography } from "@mui/material";
import emptyState from "../../../assets/emptyState.svg";

export default function EmptyStateNotFound(props: { title?: string }) {
  return (
    <>
      <div style={{ width: "60%", marginTop: "5%" }}>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "16px",
            padding: "10px",
          }}
        >
          {props.title ? props.title : "Página não encontrada"}
        </Typography>
        <img
          style={{
            width: "50%",
          }}
          src={emptyState}
          alt="não encontrado"
        />
      </div>
    </>
  );
}

export function EmptyTable(props: { title?: string }) {
  const { title } = props;
  return (
    <Box
      sx={{
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "16px",
          padding: "10px",
        }}
      >
        {title ?? "Nenhum registro encontrado"}
      </Typography>
    </Box>
  );
}
